<div class="modal-header">
  <h5 class="modal-title">Additional Project Settings</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>
<div class="modal-body">
  <form [formGroup]="additionalProjectSettingsForm">
      <div>
        <label>Show Removal Stage</label>
        <div>
            <div class="form-check form-check-inline">
                  <input id="REMOVAL_STAGE_YES" class="form-check-input" type="radio"
                    formControlName="removal" [value]="true">
                <label for="REMOVAL_STAGE_YES" class="form-check-label"
                    style="font-weight: normal;">Yes</label>
            </div>
            <div class="form-check form-check-inline">
                <input id="REMOVAL_STAGE_NO" class="form-check-input" type="radio"
                    formControlName="removal" [value]="false">
                <label for="REMOVAL_STAGE_NO" class="form-check-label"
                    style="font-weight: normal;">No</label>
            </div>
        </div>
      </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="!additionalProjectSettingsForm.valid" (click)="updateProject($event);">Save</button>
  <button type="button" class="btn btn-secondary" (click)="modal.dismiss();">Close</button>
</div>
